<template>
    <div class="p-5">
        <div v-if="cadhConfig.offers && cadhConfig.offers.length === 0 && offers && offers.length === 0"
             class="text-center d-flex flex-column">
            <div>
                <button class="text-center cadh-add-button" @click="openCreateModal">
                    <span class="font-weight-bold h4">
                        + <br>
                        Ajouter une <br>
                        offre
                    </span>
                </button>
            </div>

            <div class="mt-2">
                <a href="https://www.loom.com/share/dbf339324f824ae7a3ffde3e09f51649" target="_blank">
                    C'est quoi ?
                    <v-icon color="primary">open_in_new</v-icon>
                </a>
            </div>
        </div>

        <div v-else>
            <div class="d-flex justify-content-end mb-4">
                <v-btn class="text-none default-button mr-4" @click="openCreateModal">
                    <v-icon class="mr-1" color="white" dense>
                        add
                    </v-icon>
                    Ajouter une offre
                </v-btn>

                <v-menu end transition="slide-y-transition" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="text-none default-button" v-on="on" :disabled="!selectedOffers.length">
                            Sur la sélection
                            <v-icon>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>

                    <v-list>
                        <v-list-item @click="deleteMultipleOffers" :disabled="usedInCampaign">
                            <v-list-item-title>
                                <v-icon class="custom-button-error">delete</v-icon>
                                Supprimer les ({{ selectedOffers.length }}) offres
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>

            <div>
                <filters></filters>
            </div>

            <v-simple-table class="mt-5">
                <thead>
                <tr>
                    <th class="text-left border-0" width="25px"></th>
                    <th class="text-left" width="40px">
                        <v-checkbox style="padding-top: 0 !important;"
                                    class="p-0 m-0"
                                    v-model="selectAll"
                                    @change="toggleSelectAll"
                                    hide-details>
                        </v-checkbox>
                    </th>
                    <th class="text-left">Nom</th>
                    <th class="text-left">Prix</th>
                    <th class="text-left">Statut</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>

                <draggable v-model="filteredOffers"
                           tag="tbody"
                           handle=".drag-handle"
                           :scroll-sensitivity="200"
                           :force-fallback="true"
                           :options="{
                                animation: 200,
                                ghostClass: 'sortable-ghost',
                                chosenClass: 'sortable-chosen'
                           }"
                           @start="setCopyOffers"
                           @end="onDragEnd"
                           @change="reorderOffers">
                    <tr v-for="offer in filteredOffers">
                        <td class="border-0">
                            <v-icon class="drag-handle page__grab-icon" color="gray">mdi-drag</v-icon>
                        </td>
                        <td>
                            <v-checkbox style="padding-top: 0 !important;"
                                        class="p-0 m-0"
                                        v-model="offer.selected"
                                        @change="updateSelectAllState"
                                        hide-details>
                            </v-checkbox>
                        </td>
                        <td>
                            <button @click="openUpdateModal(offer)" class="text-primary text-start">
                                {{ offer.label }}
                            </button>
                        </td>
                        <td>
                            <div v-if="offer.params.length === 0">
                                {{ formatPrice(offer.price / 100) }}&nbsp;€
                            </div>
                            <div v-else-if="offer.params[0].field_type === 'quantifiable'">
                                {{ formatPrice(offer.price / 100) }}&nbsp;€ et {{ formatPrice(offer.params[0].values[0].price / 100) }}&nbsp;€ par unité
                            </div>
                            <div v-else>
                                Au choix
                            </div>
                        </td>
                        <td>{{ offer.hidden ? "Masquée" : "Active" }}</td>
                        <td class="text-right">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small icon v-on="on" color="primary" class="custom-button-error"
                                           @click="openUpdateModal(offer)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Modifier</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="ml-3 mr-3" small icon v-on="on" @click="duplicateOffer(offer)">
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Dupliquer</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <button v-on="on" class="cadh-config-button-icon" v-if="!usedInCampaign"
                                            @click="deleteOffer(offer)">
                                        <v-icon color="error">delete</v-icon>
                                    </button>
                                </template>
                                <span>Supprimer</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </draggable>

            </v-simple-table>
        </div>

        <v-dialog ref="dialog" v-model="offerModal" persistent max-width="1200px" fullscreen :retain-focus="false">
            <create-offer-modal ref="modale"
                                :offer="selectedOffer"
                                :mode="modalMode"
                                :priceType="priceType"
            ></create-offer-modal>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import CreateOfferModal from "./CreateOfferModal.vue"
import Confirm from "../../tools/Confirm.vue"
import Filters from "./Filters.vue"
import draggable from "vuedraggable"
import draggableMixin from "@/mixins/draggableMixin"

export default {
    name: "CadhConfigOffers",
    components: { Filters, CreateOfferModal, Confirm, draggable },
    mixins: [draggableMixin],
    data() {
        return {
            copyOffers: [],
            selectAll: false,
            modalMode: null,
            selectedOffer: null,
            priceType: "",
            filteredOffers: [],
        }
    },
    methods: {
        ...mapMutations("cadhConfig", ["setCurrentStep", "setCadhConfig", "resetState", "setModalCurrentStep",
            "setConfigOffers", "setOfferModal"]),
        openCreateModal() {
            this.modalMode = "create"
            this.selectedOffer = {
                "label": "",
                "description": "",
                "price": "0",
                "criterias": [],
                "multiple": false,
                "hidden": false,
                "params": [],
                "max_price": "",
                "operation_type": "A",
                "order": this.offers.length + 1,
            }
            this.priceType = this.definePriceType()
            this.setModalCurrentStep("1")
            this.setOfferModal(true)
        },
        toggleSelectAll() {
            this.filteredOffers.forEach(item => {
                item.selected = this.selectAll
            })
        },
        deleteOffer(offer) {
            this.$refs.confirm.open("Attention", "Voulez-vous vraiment supprimer cette offre ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$store.dispatch("cadhConfig/deleteOffer", offer.id)
                }
            })
        },
        deleteMultipleOffers() {
            this.$refs.confirm.open("Attention", "Voulez-vous vraiment supprimer les offres sélectionnées ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    let payload = {
                        "ids": this.selectedOffers.map(offer => offer.id),
                    }

                    this.$store.dispatch("cadhConfig/deleteOffers", payload)
                }
            })
        },
        definePriceType() {
            if (this.selectedOffer.params.length === 0) {
                return "Fixe"
            } else {
                if (this.selectedOffer.params[0].field_type === "quantifiable") {
                    return "Par unité"
                } else {
                    return "Au choix"
                }
            }
        },
        openUpdateModal(offer) {
            this.modalMode = "update"
            this.selectedOffer = JSON.parse(JSON.stringify(offer))
            this.priceType = this.definePriceType()
            this.selectedOffer.description = this.selectedOffer.description !== null ? this.selectedOffer.description : ""
            this.preparePrice()
            this.setModalCurrentStep("1")
            this.setOfferModal(true)
        },
        duplicateOffer(offer) {
            this.modalMode = "create"
            this.selectedOffer = JSON.parse(JSON.stringify(offer))
            this.selectedOffer.order = this.cadhConfig.offers.length + 1
            this.selectedOffer.description = this.selectedOffer.description !== null ? this.selectedOffer.description : ""
            this.preparePrice()
            this.priceType = this.definePriceType()
            this.setModalCurrentStep("1")
            this.setOfferModal(true)
        },
        preparePrice() {
            this.selectedOffer.price = this.selectedOffer.price / 100

            this.selectedOffer.params.forEach(param => {
                param.values.forEach(value => {
                    value.price = value.price / 100
                })
            })

            this.selectedOffer.max_price = this.selectedOffer.max_price / 100
        },
        setCopyOffers(event) {
            this.copyOffers = JSON.parse(JSON.stringify(this.offers))

            this.onDragStart(event)
        },
        reorderOffers(event) {
            if (event.moved) {
                const pointerType = event.moved.newIndex !== this.offers.length - 1 ? "before" : "after"
                const moveObject = event.moved.element.id
                const pointerId = this.copyOffers[event.moved.newIndex].id

                this.$store.dispatch("cadhConfig/reorderList", [
                    "cadh_offers",
                    this.cadhConfig.id,
                    pointerId,
                    pointerType,
                    moveObject,
                ]).then(res => {
                    this.offers = res.body.data.items
                })
            }
        },
        updateSelectAllState() {
            const allSelected = this.offers.every(item => item.selected)
            this.selectAll = allSelected
        },
        filerByQuestions() {
            return this.offers.filter(data => {
                return this.checkIfDataHasCriterias(data)
            })
        },
        checkIfDataHasCriterias(data) {
            let hasCriteria = false
            let criteriasIds = data.criterias.map(criteria => criteria.id)
            let newArray = []
            let resultsArray = []

            this.criteriaFamilies.forEach(family => {
                newArray[family.id] = family.criterias.filter(criteria => {
                    return this.criteriasFilter.includes(criteria.id)
                })
            })

            newArray.forEach(array => {
                if(array.length > 0) {
                    hasCriteria = array.map(obj => obj.id).some(value => criteriasIds.includes(value))
                    resultsArray.push(hasCriteria)
                }
            })

            return resultsArray.every((value) => value === true)
        },
        filterByName() {
            return this.offers.filter(type => {
                return type.label.toLowerCase().includes(this.searchName)
            })

        },
        filerByNameAndCriterias() {
            return this.offers.filter(type => {
                return type.label.toLowerCase().includes(this.searchName) && this.checkIfDataHasCriterias(type)
            })
        },
        setFilteredData(datas = null) {
            if (datas === null) {
                datas = this.offers
            }

            this.filteredOffers = datas
        },
        useRightFilter() {
            if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length === 0) {
                this.setFilteredData()
            } else if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length > 0) {
                this.setFilteredData(this.filerByQuestions())
            } else if (this.criteriasFilter.length === 0 && this.searchName !== "" && this.searchName !== null) {
                this.setFilteredData(this.filterByName())
            } else {
                this.setFilteredData(this.filerByNameAndCriterias())
            }
        },
        formatPrice(price) {
            return price.toFixed(2).toString().replace('.', ',')
        },
    },
    computed: {
        ...mapState("cadhConfig", ["cadhConfig", "configOffers", "offerModal", "criteriasFilter", "searchName",
            "usedInCampaign", "criteriaFamilies"]),
        offers: {
            get() {
                return this.configOffers
            },
            set(value) {
                this.$store.commit("cadhConfig/setConfigOffers", value)
            },
        },
        selectedOffers() {
            return this.filteredOffers.filter(offer => offer.selected)
        },
    },
    watch: {
        searchName() {
            this.useRightFilter()
        },
        criteriasFilter() {
            this.useRightFilter()
        },
        offers() {
            if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length === 0) {
                this.filteredOffers = this.offers
            } else if ((this.searchName === "" || this.searchName === null) && this.criteriasFilter.length > 0) {
                this.filteredOffers = this.filerByQuestions()
            } else if (this.criteriasFilter.length === 0 && this.searchName !== "" && this.searchName !== null) {
                this.filteredOffers = this.filterByName()
            } else {
                this.filteredOffers = this.filerByNameAndCriterias()
            }
        },
    },
}
</script>